<template>
    <div class="fulfillment-attachment-file">
        <DsIcon
            name="attach"
            class="file-icon"
        />
        <span class="file-name">
            {{ file.fileName }}
        </span>
        <span class="file-size">
            {{ sizeInMegabytes }}
        </span>
        <DsIconButton
            name="minus-circle"
            class="file-delete"
            :alt-text="`Delete file ${file.fileName}`"
            @click="deleteFile(file.fileBoxId)"
        />
        <div class="line-separator" />
    </div>
</template>

<script>
export const KILOBYTE = 1024;
export const KILOBYTE_UNIT = 'KB';
export const MEGABYTE_UNIT = 'MB';

export default {
    KILOBYTE_UNIT,
    MEGABYTE_UNIT,
    KILOBYTE,

    props: {
        file: {
            type: Object,
            required: true,
        },
    },

    emits: ['delete-file'],

    computed: {
        sizeInMegabytes() {
            let size = '--';

            if (this.file.fileSize) {
                if (this.file.fileSize < KILOBYTE * KILOBYTE) {
                    size = `${(this.file.fileSize / KILOBYTE).toFixed(2)} ${KILOBYTE_UNIT}`;
                } else {
                    size = `${(this.file.fileSize / (KILOBYTE * KILOBYTE)).toFixed(2)} ${MEGABYTE_UNIT}`;
                }
            }

            return size;
        },
    },

    methods: {
        deleteFile(fileId) {
            this.$emit('delete-file', fileId);
        },
    },
};
</script>
<style lang="scss" scoped>
.fulfillment-attachment-file {
    display: grid;
    grid-template-areas: 'fileicon filename filedelete' 'fileicon filesize filedelete' 'fileicon line line ';
    grid-template-columns: px-to-rem(72) auto px-to-rem(48);
    grid-template-rows: 49% 49% 2%;
    align-items: center;
}
.file-icon {
    grid-area: fileicon;
    height: px-to-rem(64);
}
.file-name {
    grid-area: filename;
    height: px-to-rem(32);
    font-size: $font-size-md;
    font-weight: 400;
    line-height: $line-height-lg;
    padding: px-to-rem(10) 0;
}
.file-size {
    grid-area: filesize;
    height: px-to-rem(32);
    color: $color-ink-800;
    font-size: $font-size-sm;
    font-weight: 400;
    line-height: $line-height-lg;
    padding: px-to-rem(2) 0;
}
.file-delete {
    grid-area: filedelete;
}
.line-separator {
    grid-area: line;
    border-top: 1px solid $color-gray-100;
    width: 100%;
}
</style>
